<dx-menu *ngIf="useElipsesButton" (onItemClick)="onEllipsisButtonClicked($event)" class="ellipses-control">
    <dxi-item icon="overflow">
        <dxi-item *ngFor="let item of ellipsesMenuItems" 
            [disabled]="!item.isEnabled"
            [text]="item.labelName">
        </dxi-item>
    </dxi-item>
</dx-menu>